import { BasicFacetWithTermsV2, FacetFilterWithTerms } from '@ravago/shared/page-data/models/elastic';

import { FacetGroup, FacetGroupStructureV2 } from '../models/facet-group.model';

export const getActiveFacetLabelsV2 = (facet: BasicFacetWithTermsV2, facetGroup: FacetGroupStructureV2): string | undefined =>
   facet.terms
      .map((facetTerm) => {
         const nestedFacetGroupContent = facetGroup.facets
            .find((f) =>
               f.nestedFacetGroups?.some((facetStructure) =>
                  facetStructure?.facets?.some((nestedFacetStructure) => nestedFacetStructure?.key === facetTerm.key)
               )
            )
            ?.nestedFacetGroups?.flatMap((nf) => nf.facets);

         const facetGroupContent = nestedFacetGroupContent
            ? nestedFacetGroupContent.find((f) => f.key === facetTerm.key)
            : facetGroup.facets.find((f) => f.key === facetTerm.key);

         if (!facetGroupContent) return undefined;

         let { label } = facetGroupContent;

         if (facetTerm?.range?.min !== undefined && facetTerm?.range?.max !== undefined) {
            if (facetGroup.identifier.collectionGroup) {
               label = `${facetTerm.range.min} - ${facetTerm.range.max}`;
            } else {
               label = `${label} ${facetTerm.range.min} - ${facetTerm.range.max}`;
            }
         }

         return label;
      })
      .filter((label) => !!label)
      .join(', ');

export const getActiveFacetLabel = (facetFilter: FacetFilterWithTerms | undefined, facetGroup: FacetGroup | undefined): string | undefined => {
   if (!facetFilter) return undefined;
   return facetFilter.terms
      .map((t) => {
         const facetGroupContent = facetGroup?.facets?.find((f) => f.name === t.term);

         if (!facetGroupContent) return undefined;

         let { label } = facetGroupContent;

         if (t?.range?.min && t?.range?.max) {
            label = `${label} ${t.range.min} - ${t.range.max}`;
         }

         if (t.nestedFacets) {
            const nestedLabels = t.nestedFacets
               .map((n) => {
                  const nestedFacetGroup = facetGroupContent.nestedFacets?.find((nestedFacet) => nestedFacet.identifier.key === n.facet);
                  return getActiveFacetLabel(n, nestedFacetGroup);
               })
               .filter((value) => !!value)
               .join(', ');
            label = `${label} (${nestedLabels})`;
         }

         return label;
      })
      .filter((label) => !!label)
      .join(', ');
};
